<div class="dialog-broadcast">
  <ng-container *ngIf="stage === 1">
    <h2>Broadcast a message to {{ dialogData.threads.length }} guests</h2>
    <p class="night nomargin">
      This will allow you to send a mass message to the guests you selected. You can choose from your canned responses.
      You can create a new one by clicking “create new” button below.
    </p>

    <div class="cr-container" fxLayout fxLayoutAlign="start start" fxLayoutGap="16px">
      <mat-form-field fxFlex>
        <input
          type="text"
          matInput
          placeholder="Select a canned response to send..."
          [(ngModel)]="selectedCr"
          (ngModelChange)="searchUpdated($event)"
          [matAutocomplete]="auto" />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="autocompleteDisplayFn">
          <mat-option *ngFor="let option of cannedResponses | async" [value]="option">
            {{ option.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <button
        mat-flat-button
        class="button__secondary"
        [routerLink]="['/gx/canned-responses']"
        (click)="this.dialogRef.close()">
        Create new
      </button>
    </div>

    <div *ngIf="selectedCr?.id" class="preview-cr pre-wrap" [innerHTML]="selectedCr.rule_preview"></div>

    <div class="buttons" fxLayout fxLayoutAlign="end center" fxLayoutGap="16px">
      <button mat-flat-button class="button__secondary" (click)="this.dialogRef.close()">Cancel</button>
      <button
        [disabled]="!selectedCr?.id"
        mat-flat-button
        class="button__primary send-messages"
        (click)="sendMessages()">
        Send to {{ dialogData.threads.length }} guests
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="stage === 2">
    <h2>Sending the message to {{ dialogData.threads.length }} guests</h2>

    <div class="sending-container">
      <div
        *ngFor="let thread of dialogData.threads"
        class="sending-item"
        [class.sending-sending]="thread.send_status === 'Sending'"
        [class.sending-sent]="thread.send_status === 'Sent'"
        [class.sending-failed]="thread.send_status === 'Failed'"
        fxLayout>
        <span fxFlex>{{ thread.guest.name }}</span>
        <span class="send-status-label" [class.night-lighter]="thread.send_status === 'Waiting'">
          {{ thread.send_status }}
        </span>
      </div>
    </div>

    <div fxLayoutAlign="end center">
      <div *ngIf="countOfSentMessages() !== dialogData.threads.length" class="send-status">
        {{ countOfSentMessages() }}/{{ dialogData.threads.length }} messages sent
      </div>

      <button
        *ngIf="countOfSentMessages() === dialogData.threads.length"
        mat-flat-button
        class="button__primary refresh-inbox"
        (click)="refreshInbox()">
        Refresh inbox
      </button>
    </div>
  </ng-container>
</div>
